<template>

    <div class="wrapper">

        <Header />

        <Middle />

        <Footer />

    </div>

</template>

<script>

import Header   from '@/components/Header.vue'
import Middle   from '@/components/Middle.vue'
import Footer   from '@/components/Footer.vue'

export default {

    name: 'AurusAppSupport',

    components: {

        Header,
        Middle,
        Footer
    }
}
</script>

<style lang="scss">
@import '@/assets/styles/scss/layout';
</style>